module.exports = __webpack_public_path__ + "img/radio_play.ab350f2a.svg";